module.exports = __webpack_public_path__ + "static/img/chart_title3.56569912.png";